import { useCallback, useEffect } from 'react';

import { User } from '@repo/domain/user';
import memoize from 'lodash/memoize';

import userApi from 'global/userApi';

const getUser = memoize(
  async (slug): Promise<User | null> => {
    const user = await userApi
      .getPublicUser(slug)
      .catch((error) => ({ error }));
    if (!user.error) {
      return user;
    }
    return null;
  },
  (slug) => slug
);

const useUserReference = (): ((slug: string) => Promise<User | null>) => {
  const getMemoizedUser = useCallback(async (slug: string) => {
    const lowerCaseText = slug.toLowerCase();
    const searchString = lowerCaseText.startsWith('@')
      ? lowerCaseText.substring(1)
      : lowerCaseText;

    if (!searchString) {
      return null;
    }
    return await getUser(searchString);
  }, []);

  useEffect(() => {
    return () => getUser.cache.clear && getUser.cache.clear();
  }, []);

  return getMemoizedUser;
};

export default useUserReference;
